/*
 * This file is part of ng2-json-editor.
 * Copyright (C) 2017 CERN.
 *
 * ng2-json-editor is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License as
 * published by the Free Software Foundation; either version 2 of the
 * License, or (at your option) any later version.
 *
 * ng2-json-editor is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with ng2-json-editor; if not, write to the Free Software Foundation, Inc.,
 * 59 Temple Place, Suite 330, Boston, MA 02111-1307, USA.
 * In applying this license, CERN does not
 * waive the privileges and immunities granted to it by virtue of its status
 * as an Intergovernmental Organization or submit itself to any jurisdiction.
 */

import {
  Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, OnInit, Output,
  EventEmitter, OnDestroy
} from '@angular/core';

import { CategorizedValidationProblems } from '../shared/interfaces';
import { Subscription } from 'rxjs/Subscription';


export class BottomConsoleComponent {

   isOpen = false;
   activeTab = '';

   onCollapse = new EventEmitter<boolean>();

  closePanel() {
    this.onCollapse.emit(false);
  }

  isActive(tabName: string): boolean {
    return tabName === this.activeTab;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'bottom-console',
  styles: [""],
  template: "<div *ngIf=\"isOpen\" class=\"bottom-console-container\"> <tabset> <tab [active]=\"isActive('Errors')\"> <problems-console-tab [problemType]=\"'errors'\"></problems-console-tab> </tab> <tab [active]=\"isActive('Warnings')\"> <problems-console-tab [problemType]=\"'warnings'\"></problems-console-tab> </tab> <tab [active]=\"isActive('Patches')\"> <patches-console-tab></patches-console-tab> </tab> <tab (select)=\"closePanel()\" [customClass]=\"'pull-right'\"> <ng-template tabHeading> <i class=\"fa fa-window-close\"></i> </ng-template> </tab> </tabset> </div>",
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isOpen': [{ type: Input },],
'activeTab': [{ type: Input },],
'onCollapse': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
